// import React from "react";
// import { createRoot } from "react-dom/client";

// import App from "./app/App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "./assets/scss/main.scss";

// // Import Swiper styles
// import "swiper/scss";

// createRoot(document.getElementById("root")).render(
//   <BrowserRouter basename="/">
//     <App />
//   </BrowserRouter>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom"; // Change this import

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/main.scss";

// Import Swiper styles
import "swiper/scss";

createRoot(document.getElementById("root")).render(
  <HashRouter>
    {" "}
    {/* Remove basename prop and change to HashRouter */}
    <App />
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
